import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="resizeobserver" id="resizeobserver"></a>
    <h1 {...{
      "id": "windowresizeobserver"
    }}>{`window.ResizeObserver`}</h1>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserver"
      }}>{`ResizeObserver`}</a><br parentName="p"></br>{`
`}<strong parentName="p">{`Since`}</strong>{`: v8.1  `}</p>
    <a name="new-resizeobserver-new" id="new-resizeobserver-new"></a>
    <h2 {...{
      "id": "resizeobservercallback"
    }}>{`ResizeObserver(callback)`}</h2>
    <p>{`Provides a mechanism to observe changes to the size of an element's content or border box.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`callback`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`ResizeObserverCallback`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The function called whenever a resize event is triggered.`}</td>
        </tr>
      </tbody>
    </table>
    <a name="resizeobserver-observe" id="resizeobserver-observe"></a>
    <h2 {...{
      "id": "observetarget-options"
    }}>{`observe(target, `}{`[options]`}{`)`}</h2>
    <p>{`Starts observing the specified target element for size changes.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserver/observe"
      }}>{`ResizeObserver - observe`}</a><br parentName="p"></br>{`
`}<strong parentName="p">{`Since`}</strong>{`: v8.1  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`target`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Element`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The element to be observed.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[options]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`{}`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Options to configure the observation. Default is `}<inlineCode parentName="td">{`{ box: "content-box" }`}</inlineCode>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[options.box]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Specifies which box model to observe. Can be "content-box" or "border-box".`}</td>
        </tr>
      </tbody>
    </table>
    <a name="resizeobserver-unobserve" id="resizeobserver-unobserve"></a>
    <h2 {...{
      "id": "unobservetarget"
    }}>{`unobserve(target)`}</h2>
    <p>{`Stops observing the specified target element.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserver/unobserve"
      }}>{`ResizeObserver - unobserve`}</a><br parentName="p"></br>{`
`}<strong parentName="p">{`Since`}</strong>{`: v8.1  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`target`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Element`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The element to stop observing.`}</td>
        </tr>
      </tbody>
    </table>
    <a name="resizeobserver-disconnect" id="resizeobserver-disconnect"></a>
    <h2 {...{
      "id": "disconnect"
    }}>{`disconnect()`}</h2>
    <p>{`Disconnects the ResizeObserver instance from all observed target elements.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserver/disconnect"
      }}>{`ResizeObserver - disconnect`}</a><br parentName="p"></br>{`
`}<strong parentName="p">{`Since`}</strong>{`: v8.1  `}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      